import SecondaryLeftNavigation from '@/components/SecondaryLeftNavigation'
import { useDesignMode } from '@/features/designMode/designModeStore'
import { useDocumentPreviewOptional } from '@/features/documentPreview/useDocumentPreview'

export function AppShellSecondaryNavSlot({ secondaryNavProps }) {
  const designMode = useDesignMode()
  const preview = useDocumentPreviewOptional()
  const collapsedForRail = Boolean(preview?.isOpen)
  if (designMode) return null
  return <SecondaryLeftNavigation {...secondaryNavProps} collapsedForRail={collapsedForRail} />
}
